// Saga Effects
import { all, call } from 'redux-saga/effects';
import userDataSaga from './slices/userSaga';
import customerDataSaga from './slices/customer/customerSaga';
import branchDataSaga from './slices/branch/branchSaga';
import lookupDetailsDataSaga from './slices/lookMaster/lookupDetails.saga';
import testRequestDataSaga from './slices/testRequest/testRequestSaga';
import labTestDataSaga from './slices/lab/labSaga';
import generatedSampleId from './slices/generatedSampleId/generatedSampleIdSaga';
import testTemplateDataSaga from './slices/testTemplate/testTemplate.saga';
import costingDataSaga from './slices/costingInvoicing/costingInvoicing.Saga';
import trackingPickupSaga from './slices/pickupTracking/pickupTracking.saga';
import gaiapodSaga from './slices/gaiapod/gaiapod.saga';
import mapsSaga from './slices/maps/maps.saga';
import pricingListSaga from './slices/pricingList/pricingList.saga';
import { watchInvoiceReports } from './slices/invoiceReports/invoiceReports.saga';

export default function* rootSaga() {
    yield all([
        call(userDataSaga),
        call(customerDataSaga),
        call(branchDataSaga),
        call(lookupDetailsDataSaga),
        call(testRequestDataSaga),
        call(labTestDataSaga),
        call(generatedSampleId),
        call(testTemplateDataSaga),
        call(costingDataSaga),
        call(trackingPickupSaga),
        call(gaiapodSaga),
        call(mapsSaga),
        call(pricingListSaga),
        call(watchInvoiceReports)
    ]);
}
